<template>
    <div class="layout">
        <div class="layout__header">
            <div class="lyaout__title">
                <!-- <h5>Referir Tarjetas</h5> -->
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button v-show="id !== ''" type="button" @click="imprimir" class="btn-info btn--bigger">
                        <i class="fa fa-print"></i><span>Imprimir</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                    <div class="select2-field">
                        <v-select @search="searchVendedores" @input="inputVendedor" label="descripcion" id="vendedor_id" v-model="selectedVendedor" :options="vendedores"></v-select>
                        <label for="vendedor_id">
                            Vendedor a referir
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <k-table-select
                    v-model="tarjetas"
                    :columnas="[
                        {
                            nombre: 'numero_documento',
                            descripcion: 'Número de documento',
                            link: true
                        },
                        {
                            nombre: 'cliente.descripcion_cliente',
                            descripcion: 'Cliente',
                        },
                        {
                            nombre: 'fecha',
                            descripcion: 'Fecha',
                            sortable: true,
                        },
                        {
                            nombre: 'valor_total',
                            descripcion: 'Valor total',
                            sortable: true,
                        },
                        {
                            nombre: 'valor_comision',
                            descripcion: 'Comisión',
                            money: true,
                            sortable: true,
                        }
                    ]"
                    :params="{
                        supervisor_id: supervisor_id,
                        tipoVenta: 'LQ',
                        liquidacion_id: liquidacionId
                    }"
                    @cerrar="cerrar"
                    @seleccionar="referir"
                    :cargaAutomatica="false"
                    :urlConsulta="url + '/ventas-nomina-supervisor'"
                    title=""
                    ref="kTableSelectVen"
                ></k-table-select>
            </div>
        </div>
    </div>
</template>

<script>
import KTableSelect from '../general/KTableSelect.vue';
export default {
    components: {
        KTableSelect
    },
    props: {
        liquidacionId: {
            type: String,
            required: false,
            default: ''
        },
        supervisor_id: {
            type: String,
            required: false,
            default: ''
        },
        valor_referido: {
            type: Number,
            required: false,
            default: 1.5
        }
    },
    methods: {
        searchVendedores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.vendedores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
            xmlhttp.send();
        },
        inputVendedor: function () {
            if (this.selectedVendedor != null)
                this.vendedor_id = this.selectedVendedor.id;
            else 
                this.vendedor_id = '';
        },
        referir: function (tarjetas) {
            if (this.selectedVendedor == null) {
                swal('Debe seleccionar un vendedor.', 'Aviso', 'warning');
                return;
            }
            swal({
                title: "¿Deseas referir las ventas seleccionadas? Tarj. Referidas: " + tarjetas.length + '(' + this.moneyFormat(tarjetas.length * this.valor_referido) + ')',
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Referir",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    let referidas = [];
                    for (let i = 0; i < tarjetas.length; i++) {
                        referidas.push({
                            pedido_id: tarjetas[i].id,
                            valor_referido: this.valor_referido
                        });
                    }
                    axios.post(url + '/liquidacion-ventas/' + this.liquidacionId + '/referir', {
                        tarjetas: referidas,
                        vendedor_id: this.vendedor_id
                    }).then(({data}) => {
                        this.id = data.id;
                        swal('Las tarjetas seleccionadas fueron refieridas exitósamente.', 'Realizado', 'success');
                    }).catch(() => {
                        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });
        },
        cerrar: function () {
            this.$emit('cerrar');
        },
        cargarTarjetas: function () {
            axios.get(url + '/liquidacion-ventas/' + this.liquidacionId + '/referidas').then(({data}) => {
                this.selectedVendedor = data.vendedor;
                this.inputVendedor();
                this.tarjetas.splice(0, this.tarjetas.length);
                for (let i = 0; i < data.tarjetas.length; i++) {
                    this.tarjetas.push(data.tarjetas[i]);
                }
                this.id = data.id;
                this.$refs.kTableSelectVen.consultar(true);
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        imprimir: function () {
            window.open(url + '/referidas/' + this.id, '_blank');
        }
    },
    mounted: function () {
        this.cargarTarjetas();
    },
    data: function () {
        return {
            tarjetas: [],
            url: url,
            selectedVendedor: null,
            vendedor_id: '',
            vendedores: [],
            moneyFormat: moneyFormat,
            id: ''
        };
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/ReferirTarjetas.vue